// =====================================================================================
// INVRT Radar - web console - the probe/test-records detector (story P2-UI, Mark's ruling)
//
// The live-fire estate carries probe organisations alongside client accounts. They are
// fixtures of the testing regime, not tenants, so the operator console hides them behind
// an explicit "Show test records" toggle (default OFF) instead of mixing them into the
// default views. The detector is name-based on purpose: the probes arrive from the estate's
// own tooling with self-describing names, and no flag on the organisation row marks them.
// =====================================================================================

/** The toggle's accessible name, shared by every surface that offers it. */
export const TEST_RECORDS_TOGGLE_LABEL = "Show test records";

/**
 * The probe-name vocabulary, as one case-insensitive pattern: underscore-wrapped slugs
 * (any __..._probe__ fixture), probe, test, E2E, live-fire, audit and "acceptance agent"
 * (G-49 Acceptance Agent). Word boundaries keep honest clients ("Latest Ltd",
 * "Auditor Ltd") out of the net. The detector keys on this structure only, never on a
 * data-source vendor's name (the white-label law, 28 Sep): the probes are self-describing,
 * so a vendor-named probe is caught by its own probe markers.
 */
const TEST_RECORDS_PATTERN =
  /(^__|__$|__|[-_\s]probe|probe[-_\s]|[-_\s]test|test[-_\s]|e2e|live[-_\s]?fire|\baudit\b|acceptance agent)/i;

/** True when an organisation name is a probe/test record the default views must hide. */
export function isTestOrganisation(name: string): boolean {
  return TEST_RECORDS_PATTERN.test(name);
}

/** The honest count line rendered while the toggle hides test records. */
export function hiddenTestRecordsLine(count: number): string {
  const noun = count === 1 ? "test organisation" : "test organisations";
  const pronoun = count === 1 ? "it" : "them";
  return `${count} ${noun} hidden. Turn on "${TEST_RECORDS_TOGGLE_LABEL}" to see ${pronoun}.`;
}
